import { Navigate, useLocation, useParams } from "react-router-dom";

// Redirects keeping legacy /projects/* URLs working after the tabbed layout was
// retired for the /home/* shell (plan §9 Phase 5). Extracted from App.jsx so they
// can be unit-tested without importing the Firebase/Three.js-heavy entry point.
export const LEGACY_PROJECTS_TAB_TARGETS: Record<string, string> = {
  projects: "/home/projects",
  boards: "/home/boards",
  collections: "/home/collections",
  recent: "/home/dashboard",
};

export const LegacyProjectsRedirect = () => {
  const { tab } = useParams();
  const target =
    LEGACY_PROJECTS_TAB_TARGETS[tab?.toLowerCase() ?? ""] || "/home/boards";
  return <Navigate to={target} replace />;
};

// /projects/show/:id links were copied to users by ShareResourceModal — they
// must keep resolving.
export const LegacyProjectShowRedirect = () => {
  const { id } = useParams();
  return <Navigate to={`/home/projects/${id}`} replace />;
};

// The board editor moved from /project/:id to /board/:id. ~500k external links
// (shares, bookmarks, emails) reference the old URL, so this redirect is
// permanent. Sentinel ids (new, new_from) and the query string are load-bearing
// (?id= for new_from, ?conceptId=, ?collectionId=, ?composeProductIdsToken=,
// ?autoCompose=1) and must flow through untouched, as must the hash.
export const LegacyProjectEditorRedirect = () => {
  const { id } = useParams();
  const { search, hash } = useLocation();
  return <Navigate to={`/board/${id ?? "new"}${search}${hash}`} replace />;
};
